import { action } from 'easy-peasy';
import { IActionDeleteMedication } from '../types';

const deleteMedication: IActionDeleteMedication = action((state, id) => {
  state.items = state.items.filter(item => item.id !== id);
});

export default deleteMedication;
